import { AxiosError } from "axios";
import type { HTTPError } from "@commons/types/api/api.types";

export function isHTTPError(error: unknown): error is HTTPError {
  return (
    error instanceof AxiosError &&
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    typeof (error as HTTPError).response === "object" &&
    "data" in (error as HTTPError).response &&
    "dataMsg" in (error as HTTPError).response
  );
}
